import * as echarts from 'echarts';
// 引入柱状图图表，图表后缀都为 Chart
import { BarChart, PieChart, LineChart, MapChart, ScatterChart, EffectScatterChart } from 'echarts/charts';
import { Map3DChart } from 'echarts-gl/charts';
import { Grid3DComponent } from 'echarts-gl/components';
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  DatasetComponent,
  MarkPointComponent

} from 'echarts/components';
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers';
echarts.use(
  [
    TitleComponent,
    TooltipComponent,
    GridComponent,
    BarChart,
    PieChart,
    LineChart,
    MapChart,
    ScatterChart,
    EffectScatterChart,
    LegendComponent,
    DatasetComponent,
    MarkPointComponent,
    LabelLayout,
    UniversalTransition,
    CanvasRenderer,
    SVGRenderer,


    Map3DChart,
    Grid3DComponent,
  ]
);
export default echarts
